import React, { Component } from 'react';
import Mapbox from '../utils/Mapbox';
class FilterList extends Component{
    constructor(props){
       super(props);
       this.categoryList = null;
       this._catArr = [];
       this.clickHandler = this.clickHandler.bind(this);

    }

    clickHandler(e){
        let id = e.target.id,
            el = e.target;

        Mapbox.popup.remove();
        this.props.filter([]);

        this.props.map.flyTo({
            center: [55.67900, 24.19760],
            speed: 0.2,
            zoom: 15.2
        });

        if(this.props.activeFilter){
            this._catArr = [];
            this.props.setActiveFilter(false);
        }

        if (!this._catArr.includes(el.id)) {
            this._catArr.push(el.id);
            this.doFilter(this._catArr);

        } else {

            this._catArr.splice(this._catArr.indexOf(el.id), 1);
            this.doFilter(this._catArr);
        }

        let fBox = document.getElementById('map-categories').childNodes;
        fBox.forEach(function(cat) {
            if (!cat.classList.contains('mapVisuals')) {
                cat.classList.remove('selected')
            }
        });

        if (this._catArr.length) {
            this._catArr.forEach(function(cat) {
                document.getElementById(cat).parentNode.classList.add('selected');
            })
        }
        
    }

    doFilter(_catArr) {
        this.props.map.setFilter('uaeu', ['in', 'icon'].concat(_catArr.map(function(feature) { 
            return feature;
        })));
        this.props.map.setLayoutProperty('uaeu', 'visibility', 'visible');
    }

    componentWillReceiveProps(props){
        this.categoryList = props.data.map((cat)=>{
            if(cat.id){
                return  <div key={cat.id} className="filterBox" onClick={this.clickHandler}>
                        <label id={cat.id}>
                            <img src={require(`../images/${cat.id}.png`)} alt="" />{cat.title}
                        </label>
                    </div>;
            }
        });
    }
    render(){
        return(
            <div id="map-categories">
                {this.categoryList}
            </div>
        );
    }
}
export default FilterList;



// WEBPACK FOOTER //
// ./src/components/FilterList.js